import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import { Form, Input, Modal, Row, Col, Select, message, InputNumber, DatePicker, Cascader } from 'antd';
import AddProjectRole from './AddProjectRole';
import ApplyJdeCodeInfo from './ApplyJdeCodeInfo';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { getMatchOption, generateOptions } from '../../shared/selectFn';
import autoEval from '../../shared/autoEvaluation';
import { GlobalType, MedicineType, maxLayout,  commonLayout } from './constants';
import moment from 'moment';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const dateFormat = 'YYYY-MM-DD';
const GlobalTypeOption = generateOptions(GlobalType);
const MedicineTypeOption = generateOptions(MedicineType);
const SecondLineSimple = {
    '启动后常规CRC执行': '启动后',
    '可行性调研': '调研',
    '可行性调研': '调研',
    '启动前协助+启动后常规CRC执行': '启动前+启动后',
};
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]

function getRole(data, role, params, other) {
    (data || []).forEach(i => {
        params[`users[${other.idx}].userId`] = i.value;
        params[`users[${other.idx}].roleCode`] = role;
        if (role === 'PM') {
            params[`users[${other.idx}].isMain`] = i.isMain || 0;
        }
        other.idx++;
    });
}

class CreateForm extends Component {
    state = {
        byStageList: [],
        disease: {},
    }

    componentDidMount() {
        const { form: { getFieldDecorator } } = this.props;
        getFieldDecorator('investigationIdentifyCodeId');
        getFieldDecorator('investigationIdentifyCode');
        getFieldDecorator('blindInvestigationName');
        getFieldDecorator('isClinicalProject');
        getFieldDecorator('diseaseName');
        getFieldDecorator('diseaseClassName');
        getFieldDecorator('investigationAreaId');
        getFieldDecorator('investigationAreaName');
        getFieldDecorator('lineOfBusinessString');
        getFieldDecorator('lineOfBusiness');
        getFieldDecorator('investigationTypeName');
        getFieldDecorator('invAreaGroupType');
        getFieldDecorator('secondLineIds');
        getFieldDecorator('secondLineNames');
        getFieldDecorator('typeId');
        getFieldDecorator('investigationSponsorName');
        getFieldDecorator('contractSignCompanyName');
        getFieldDecorator('croId');
        getFieldDecorator('croName');
        getFieldDecorator('customerCompanySpecialName');
        this.init();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.record !== this.props.record) {
            this.init();
        }
    }

    init = () => {
        const { diseaseName, sponsorName, investigationMedicineType: oldMedicineType, secondResearchProductType, customerCompanyName, investigationIdentifyCode, investigationIdentifyCodeId, contractSignCompanyName, contractSignCompanyId } = this.props.record;
        this.loadCro(customerCompanyName);
        this.loadSponsor(contractSignCompanyName);
        this.loadInvestigationByStageList([oldMedicineType]);
        this.queryAllDiseaseList(diseaseName);
        // 项目阶段默认为“准备期”
        const { stageList } = this.props;
        const { typeConfigureId: prepareStageId } = getMatchOption(stageList, 'typeValue', '准备期') || {};
        // 申办方默认取合同签署方
        const params = {
            investigationIdentifyCode,
            investigationIdentifyCodeId,
            investigationMedicineType: secondResearchProductType ? [oldMedicineType, secondResearchProductType] : [oldMedicineType],
        };
        if (!this.props.form.getFieldValue('stageIds') || !(this.props.form.getFieldValue('stageIds') || []).length) {
            params.stageIds = prepareStageId ? [String(prepareStageId)] : [];
        }
        if (!sponsorName && contractSignCompanyId) {
            params.investigationSponsorId = contractSignCompanyId;
            params.investigationSponsorName = contractSignCompanyName;
        }
        this.props.form.setFieldsValue(params);
    }

    loadCro = (customerCompanyName) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryCustomerCompanyByName,
            data: {
                natureName: 'CRO',
                customerCompanyName,
            },
            dataType: 'json',
            doneResult: res => {
                const params = {};
                if (!(res.data || []).length) {
                    params.croId = undefined;
                    params.croName = undefined;
                }
                this.props.form.setFieldsValue(params);
            },
        };
        $.sendRequest(options);
    }

    loadSponsor = (customerCompanyName) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryCustomerCompanyByName,
            data: {
                // natureName: '申办方',
                customerCompanyName,
            },
            dataType: 'json',
            doneResult: res => {
                const [{ customerCompanySpecialName } = {}] = res.data;
                this.props.form.setFieldsValue({ customerCompanySpecialName });
            },
        };
        $.sendRequest(options);
    }

    loadInvestigationByStageList = (investigationMedicineType) => {
        if (!investigationMedicineType || (investigationMedicineType && investigationMedicineType.length == 0)) {
            this.setState({ byStageList: [] });
        } else {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType: investigationMedicineType[0] },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ byStageList: res.data }, () => {
                        if (!this.props.form.getFieldValue('blindInvestigationId')) {
                            this.autoEvaluation();
                        }
                    });
                }
            };
            $.sendRequest(options);
        }
    }

    queryAllDiseaseList = (diseaseName) => {
        if (diseaseName) {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllDiseaseList,
                data: { keyword: diseaseName },
                dataType: 'json',
                doneResult: res => {
                    const diseaseId = this.props.form.getFieldValue('diseaseId');
                    const disease = getMatchOption(res.data, 'diseaseId', diseaseId);
                    disease.value = diseaseId;
                    disease.text = diseaseName;
                    this.handleChange(disease, 'disease');
                },
            });
        } else {
            this.handleChange({}, 'disease');
        }
    }

    handleChange = (value, key) => {
        const { form } = this.props;
        const { setFieldsValue, getFieldValue, getFieldsValue } = form;
        switch (key) {
            case 'stageIds': {
                const { levelList, stageList } = this.props;
                const params = { suspendTime: undefined };
                let newValue = (value || []).slice();
                if (newValue.length >= 2) {
                    let lastValue;
                    const { groupId: fg } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                    const { groupId: lg } = getMatchOption(stageList, 'typeConfigureId', (lastValue = newValue.slice(-1))[0]);
                    if (fg !== lg) {
                        newValue = lastValue;
                    }
                }

                const { typeValue } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                if (typeValue === '治疗结束随访期' || typeValue === '项目暂停') {
                    const levelId = getFieldValue('levelId');
                    const { typeValue: level } = getMatchOption(levelList, 'typeConfigureId', levelId);
                    if (level && level !== 'C') {
                        params.levelId = levelId + 1;
                    }
                }
                setFieldsValue(params);
                return newValue;
            }
            case 'investigationIdentifyCode': {
                const { value: id, text: name } = value;
                setFieldsValue({
                    investigationIdentifyCodeId: id || undefined,
                    investigationIdentifyCode: name || undefined,
                });
                break;
            }
            case 'investigationMedicineType': {
                setFieldsValue({
                    drugMainTargets: undefined,
                    administrationMode: undefined,
                    administrationModeRemark: undefined,
                    investigationMedicine: undefined,
                    investigationByStageId: [],
                    investigationByStageRemark: undefined,
                    treatmentMethod: this.changeTreatMethod(value),
                });
                this.loadInvestigationByStageList(value);
                return value;
            }
            case 'administrationMode':
                setFieldsValue({ administrationModeRemark: undefined });
                return value;
            case 'investigationByStageId': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || []).slice(-1));
                setFieldsValue({ investigationByStageRemark: undefined });
                setTimeout(this.autoEvaluation, 30);
                return isMultipleChoice == 1 ? value : investigationByStageId ? [String(investigationByStageId)] : [];
            }
            case 'investigationCode': {
                if (
                    getFieldValue('blindInvestigationId') &&
                    ((value || '').includes('遗传办') || (value || '').includes('安全事务'))
                ) {
                    message.warning('已关联盲态项目下，项目编号不可修改为“遗传办”、“安全事务”')
                    return;
                }
                setTimeout(this.autoEvaluation, 30);
                return value;
            }
            case 'testeeTypeId': {
                setTimeout(this.autoEvaluation, 30);
                return value;
            }
            case 'disease': {
                const { value: diseaseId, text: diseaseName, diseaseClassName, investigationAreaId, investigationAreaName, invAreaGroupType } = value;
                setFieldsValue({
                    diseaseId,
                    diseaseName: diseaseName ? diseaseName.replace(/^(NA)\(.+\)$/, '$1') : undefined,
                    diseaseClassName,
                    investigationAreaId,
                    investigationAreaName,
                    invAreaGroupType,
                });
                this.setState({ disease: value }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'blindInvestigation': {
                const {
                    value: id, text: name, investigationGlobalType, stageIds, investigationMedicineType,
                    treatmentMethod, drugMainTargets, administrationMode, administrationModeRemark,
                    investigationMedicine, investigationByStageId, investigationByStageRemark, diseaseId,
                    diseaseName, diseaseClassName, investigationAreaId, investigationAreaName, testeeTypeId,
                    lineOfBusiness, lineOfBusinessString, investigationSponsor, investigationSponsorId, cro, croId,
                    investigationSponsorSpecial,
                } = value;
                const { businessList } = this.props;
                const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
                const { typeConfigureId, typeValue } = getMatchOption(secondLineList, 'typeValue', '非盲');
                let medicineType;
                if (id) {
                    if (
                        !investigationMedicineType ||
                        !investigationByStageId ||
                        !diseaseId ||
                        !testeeTypeId ||
                        !lineOfBusiness ||
                        !typeConfigureId
                    ) {
                        message.warning('关联的盲态项目项目信息不完整，请完善！');
                        return;
                    }
                    if (!getFieldValue('blindInvestigationId')) {
                        this.prevFields = getFieldsValue();
                    }
                    setFieldsValue({
                        blindInvestigationId: id,
                        blindInvestigationName: name,
                        investigationGlobalType,
                        stageIds: stageIds ? stageIds.split(',') : [],
                        investigationMedicineType,
                        treatmentMethod,
                        drugMainTargets,
                        administrationMode,
                        administrationModeRemark,
                        investigationMedicine,
                        investigationByStageId: investigationByStageId ? investigationByStageId.split(',') : [],
                        investigationByStageRemark,
                        diseaseId,
                        diseaseName,
                        diseaseClassName,
                        investigationAreaId,
                        investigationAreaName,
                        testeeTypeId,
                        lineOfBusiness,
                        lineOfBusinessString,
                        secondLineIds: typeConfigureId,
                        secondLineNames: typeValue,
                        investigationSponsorId,
                        investigationSponsorName: investigationSponsor,
                        customerCompanySpecialName: investigationSponsorSpecial,
                        croName: cro,
                        croId,
                    });
                    medicineType = investigationMedicineType;
                } else {
                    setFieldsValue({
                        blindInvestigationId: id,
                        blindInvestigationName: name,
                        ...(this.prevFields || {})
                    });
                    medicineType = (this.prevFields || {}).investigationMedicineType;
                    this.prevFields = {};
                }
                this.loadInvestigationByStageList(medicineType);
                break;
            }
            case 'sponsor': {
                const { value: id, text: name, customerCompanySpecialName } = value;
                setFieldsValue({
                    investigationSponsorId: id,
                    investigationSponsorName: name,
                    // customerCompanySpecialName,
                });
                break;
            }
            case 'contractSignCompany': {
                const { value: id, text: name, customerCompanySpecialName } = value;
                setFieldsValue({
                    contractSignCompanyId: id,
                    contractSignCompanyName: name,
                    customerCompanySpecialName,
                });
                break;
            }
            case 'cro': {
                const { value: id, text: name } = value;
                setFieldsValue({
                    croId: id,
                    croName: name,
                });
                break;
            }
            case 'investigationGlobalType': {
                setFieldsValue({
                    levelId: value == 'Internal_Single' ? 3 : 2,
                });
                return value;
            }
            default:
                return value;
        }
    }

    saveProjectRole = (role, list) => {
        const { form: { setFieldsValue, getFieldValue } } = this.props;
        const bd = getFieldValue('bd');
        if (role === 'bd' && bd.length === 1) {
            if (!list.some(item => item.value == bd[0].value)) {
                list.push(bd[0]);
            }
        }
        setFieldsValue({ [role]: list });
    }

    autoEvaluation = () => {
        const { typeList, testeeTypeList, businessList, form, record } = this.props;
        const { byStageList, disease } = this.state;
        const { lineOfBusiness, secondLineIds, secondLineNames } = record;
        const { isClinicalProject, investigationMedicineType, investigationByStageId, investigationAreaName, testeeTypeId, investigationCode,invAreaGroupType } = form.getFieldsValue();
        form.getFieldDecorator('treatmentMethod');
        
        const params = autoEval({
            type: 'JDE',
            businessList,
            byStageList,
            typeList,
            testeeTypeList,
            disease,
            isClinicalProject,
            investigationMedicineType,
            investigationByStageId,
            investigationAreaName,
            testeeTypeId,
            invAreaGroupType,
            investigationCode
        });
        
        if (isClinicalProject == 1 && lineOfBusiness) {
            if (lineOfBusiness != params.lineOfBusiness && (params.secondLineNames !== '遗传办' && params.secondLineNames !== '安全事务')) {
                if (secondLineNames) {
                    const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', params.lineOfBusiness);
                    const { typeConfigureId, typeValue } = getMatchOption(secondLineList, 'typeValue', secondLineNames);
                    params.secondLineIds = typeConfigureId;
                    params.secondLineNames = typeValue;
                } else {
                    params.secondLineIds = '';
                    params.secondLineNames = '';
                }
            } else {
                params.secondLineIds = params.secondLineIds || secondLineIds;
                params.secondLineNames = params.secondLineNames || secondLineNames;
            }
        }
        // 自动计算条件不满足时 autoEval 会给出 undefined，直接回写会把表单里已有的业务线清空，
        // 项目简称随之消失；算不出时保留现有值，等疾病/分期数据齐全后会再次触发计算
        if (params.lineOfBusinessString === undefined) {
            delete params.lineOfBusinessString;
        }
        if (params.lineOfBusiness === undefined) {
            delete params.lineOfBusiness;
        }
        // 同上：重算不出二级分类时（如切换研究产品类型导致分期被清空），
        // 保留表单/record 已有值，避免 secondLineNames 变 undefined 后项目简称拼出 "undefined"
        if (params.secondLineIds === undefined) {
            delete params.secondLineIds;
        }
        if (params.secondLineNames === undefined) {
            delete params.secondLineNames;
        }
        form.setFieldsValue(params);
    }

    changeTreatMethod = (value) => {
        const { treatmentMethodList } = this.props;
        let text,treat = undefined;
        switch (value[1]) {
            case 'Radiation_therapy':
                text = '放射疗法（ 同位素 核药；照射 ）'
                break;
            case 'Cell_therapy':
                text = '细胞治疗: CART'
                break;
            case 'Stem_cell_therapy':
                text = '干细胞治疗'
                break;
            case 'Gene_therapy':
                text = '基因治疗'
                break;
            default:
                break;
        };
        treatmentMethodList.map(el => {
            if (el.treatMethod == text) {
                treat = el.evaluateTumorTreatMethodId;
            }
        });
        return treat
    }

    render() {
        const {
            visible, record, form, levelList, stageList, businessList,
            testeeTypeList, treatmentMethodList, administrationModeList,
        } = this.props;
        const { byStageList } = this.state;
        const { isClinicalProjectShow } = record;
        const { getFieldDecorator, getFieldsValue, setFieldsValue } = form;
        const {
            stageIds, diseaseName, investigationMedicineType = [], investigationByStageId, administrationMode,
            diseaseClassName, investigationAreaName, investigationCode, lineOfBusiness, lineOfBusinessString,
            secondLineNames, secondLineIds, investigationTypeName, customerCompanySpecialName,
            isClinicalProject, investigationSponsorName, croName, pm, pa, bd, csa, blindInvestigationName,
            blindInvestigationId, informedAmount, filterAmount, randomAmount, investigationIdentifyCode, contractSignCompanyName, treatmentMethod,
        } = getFieldsValue();

        // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
        let multiplable = true;
        let showStageOther = false;
        if ((investigationByStageId || []).length === 1) {
            const { isMultipleChoice, investigationByStageName } = getMatchOption(byStageList, 'investigationByStageId', investigationByStageId[0]);
            multiplable = isMultipleChoice == 1;
            showStageOther = investigationByStageName === '其他';
        }

        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        const showSecondLine = (secondLineList || []).length > 0;
        const isClinicalPro = isClinicalProject == 1;
        const { invNature } = getMatchOption(secondLineList, 'typeConfigureId', secondLineIds);

        const { typeValue: stageName } = getMatchOption(stageList, 'typeConfigureId', (stageIds || []).slice(-1).join());
        const showAdministrationModeOther = getMatchOption(administrationModeList, 'typeConfigureId', administrationMode).typeValue === '其他';

        const isBoundBlind = !!blindInvestigationId;    // 非盲

        let stageOption = stageList.filter(d => isBoundBlind ? true : (d.operation !== 'INVESTIGATION_DATA_LOCK' && d.operation !== 'INVESTIGATION_LEVEL_LOWEST'))
            .map(d => <Option key={d.typeConfigureId} disabled={d.typeValue === '项目待终止' || d.typeValue === '服务合同签署前终止' || d.typeValue === '业务数据归档'}>{d.typeValue}</Option>);
        //执行业务线二级分类是:遗传办、SSU主导、启动前协助、可行性调研、质量培训、安全事务、小时卡
        const secondLineNameRules = secondLineNames == '遗传办' || secondLineNames == 'SSU主导' || secondLineNames == '启动前协助' || secondLineNames == '可行性调研' || secondLineNames == '质量培训' || secondLineNames == '安全事务' || secondLineNames == '小时卡';
        if(secondLineNameRules){
            stageOption = stageList.filter(el => el.typeValue == '准备期' || el.typeValue == '项目执行工作全部完成' || el.typeValue == '项目暂停' || el.typeValue == '项目待终止' || el.typeValue == '服务合同签署前终止').map(d => <Option key={d.typeConfigureId} disabled={d.typeValue == '项目待终止' || d.typeValue == '服务合同签署前终止' || d.typeValue === '业务数据归档'}>{d.typeValue}</Option>);
        }

        //津石第一家研究中心启动计划开始时间、津石100%中心启动计划开始时间，是否必填判断
        const showSiteStartTime = secondLineNames == 'SSU主导' || secondLineNames == '启动前协助' || secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行';

        //津石首例受试者随机（入组）计划开始时间、津石100%受试者随机（入组）计划开始时间，是否必填判断
        const showGroupStartTime = secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行';

        const levelOption = levelList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        
        const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageId)} disabled={(investigationByStageId || []).length > 0 ? multiplable ? d.isMultipleChoice == 0 : d.isMultipleChoice == 1 : false}>{d.investigationByStageName}</Option>);
        const treatmentMethodOption = treatmentMethodList.map(d => <Option key={d.evaluateTumorTreatMethodId} value={d.evaluateTumorTreatMethodId}>{d.treatMethod}</Option>);
        const administrationModeOption = administrationModeList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const testeeTypeOption = testeeTypeList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        return (
            <Form>
                <div>1.基本信息</div>
                <Row>
                    <Col span={24}>
                        <FormItem label="项目简称" {...maxLayout}>
                            {
                                (diseaseName && lineOfBusinessString && investigationCode && customerCompanySpecialName) ?
                                    `${customerCompanySpecialName}-${diseaseName}-${investigationCode}（${lineOfBusinessString}${isClinicalProject == 1 ? `-${SecondLineSimple[secondLineNames] || secondLineNames}` : '' }）`
                                :
                                    ''
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="项目名称" {...maxLayout}>
                            {
                                getFieldDecorator('investigationSpecialName')(
                                    <TextArea placeholder="请输入" autosize={{ minRows: 2, maxRows: 3 }} />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <Col span={12}>
                            <FormItem label="项目识别码" {...commonLayout}>
                                {
                                    getFieldDecorator('investigationIdentifyCodeId')(<Input type="hidden" />)
                                }
                                <SearchRetrieve
                                    keyword='identifyCode'
                                    style={{ width: 182 }}
                                    placeholder="输入名称检索"
                                    params={{ limit: 20, natureName: '项目识别码'  }}
                                    value={investigationIdentifyCode}
                                    url={API_URL.contract.queryInvIdentifyCodeList}
                                    config={{ id: 'investigationIdentifyCodeId', name: 'identifyCode' }}
                                    onChange={(option) => this.handleChange(option, 'investigationIdentifyCode')}
                                />
                            </FormItem>
                        </Col>
                    </Col>
                    <Col span={24}>
                        <Col span={12}>
                            <FormItem label="项目编号" {...commonLayout}>
                                {
                                    getFieldDecorator('investigationCode', {
                                        rules: [
                                            { required: true, message: '项目编号不能为空' },
                                            { max: 30, message: '项目编号最多30个字符' },
                                        ],
                                        getValueFromEvent: e => this.handleChange(e.target.value, 'investigationCode')
                                    })(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label="项目类型" {...commonLayout}>
                                {
                                    getFieldDecorator('investigationGlobalType', {
                                        getValueFromEvent: value => this.handleChange(value, 'investigationGlobalType'),
                                        rules: [{ required: false, message: '请选择项目类型' }],
                                    })(
                                        <Select
                                            allowClear={true}
                                            placeholder="请选择"
                                            disabled={isBoundBlind}
                                        >
                                            {GlobalTypeOption}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目级别" {...commonLayout}>
                            {
                                getFieldDecorator('levelId', {
                                    rules: [{ required: true, message: '请选择项目级别' }],
                                })(
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                    >
                                        {levelOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目阶段" {...commonLayout}>
                            {
                                getFieldDecorator('stageIds', {
                                    getValueFromEvent: value => this.handleChange(value, 'stageIds'),
                                    rules: [{ required: true, message: '请选择项目阶段' }],
                                })(
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                        disabled={isBoundBlind}
                                    >
                                        {stageOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                        {
                            stageName === '项目暂停' &&
                            <FormItem label="项目暂停时间" {...commonLayout}>
                                {
                                    getFieldDecorator('suspendTime', {
                                        rules: [{ required: true, message: '请选择项目暂停时间' }],
                                    })(<DatePicker style={{ width: '100%' }} format={dateFormat} placeholder="请选择"/>)
                                }
                            </FormItem>
                        }
                        {
                            stageName === '项目终止' &&
                            <FormItem label="项目终止时间" {...commonLayout}>
                                {
                                    getFieldDecorator('terminationTime', {
                                        rules: [{ required: true, message: '请选择项目终止时间' }],
                                    })(<DatePicker style={{ width: '100%' }} format={dateFormat} placeholder="请选择"/>)
                                }
                            </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="此项目是否为临床项目" {...commonLayout}>
                            {isClinicalProjectShow}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="研究产品类型" {...commonLayout}>
                            {
                                getFieldDecorator('investigationMedicineType', {
                                    rules: [{ required: lineOfBusinessString == '肿瘤' ? true : false, message: '请选择研究产品类型' }],
                                    getValueFromEvent: value => this.handleChange(value, 'investigationMedicineType')
                                })(
                                    <Cascader
                                        allowClear={true}
                                        placeholder="请选择"
                                        disabled={isBoundBlind}
                                        options={MedicineTypeList}
                                    />
                                )
                            }
                        </FormItem>
                        {
                            (investigationMedicineType[0] === 'Research_drugs' || investigationMedicineType[0] === 'Technology') &&
                            <FormItem label="肿瘤治疗方式" {...commonLayout}>
                                {
                                    getFieldDecorator('treatmentMethod', {
                                        rules: [{ 
                                            // required: lineOfBusinessString == '肿瘤' ? true : false, 
                                            required: false, 
                                            message: '请选择肿瘤治疗方式' 
                                        }],
                                    })(
                                        <Select
                                            allowClear={true}
                                            placeholder="请输入检索"
                                            disabled={isBoundBlind}
                                            showSearch
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {treatmentMethodOption}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] &&
                            <FormItem label="药物(疗法)分类/主要作用靶点" {...commonLayout}>
                                {
                                    getFieldDecorator('drugMainTargets')(<Input placeholder="请输入" disabled={isBoundBlind} />)
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] &&
                            <FormItem label={investigationMedicineType[0] == 'Research_drugs' ? '研究药物通用名称' : investigationMedicineType[0] == 'Technology' ? '技术名称' : '产品具体名称'} {...commonLayout}>
                                {
                                    getFieldDecorator('investigationMedicine')(<Input placeholder="请输入" disabled={isBoundBlind} />)
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] == 'Research_drugs' &&
                            <FormItem label="给药方式" {...commonLayout}>
                                {
                                    getFieldDecorator('administrationMode')(
                                        <Select
                                            allowClear={true}
                                            placeholder="请选择"
                                            disabled={isBoundBlind}
                                        >
                                            {administrationModeOption}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        }
                        {
                            (investigationMedicineType[0] == 'Research_drugs' && showAdministrationModeOther) &&
                            <FormItem label="其他给药方式备注" {...commonLayout}>
                                {
                                    getFieldDecorator('administrationModeRemark')(<Input placeholder="请输入" disabled={isBoundBlind} />)
                                }
                            </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目分期" {...commonLayout}>
                            {
                                getFieldDecorator('investigationByStageId', {
                                    rules: [{ required: true, message: '请选择项目分期' }],
                                    getValueFromEvent: value => this.handleChange(value, 'investigationByStageId')
                                })(
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                        disabled={!investigationMedicineType[0] || isBoundBlind}
                                    >
                                        {byStageOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                        {
                            showStageOther &&
                            <FormItem label="其他项目分期备注" {...commonLayout}>
                                {
                                    getFieldDecorator('investigationByStageRemark', {
                                        rules: [{ required: true, message: '请输入备注' }],
                                    })(<Input placeholder="请输入" disabled={isBoundBlind} />)
                                }
                            </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="疾病" {...commonLayout}>
                            {
                                getFieldDecorator('diseaseId',
                                    { rules: [{ required: true, message: '请选择疾病' }] }
                                )(<Input type="hidden" />)
                            }
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                value={diseaseName}
                                disabled={isBoundBlind}
                                params={{ limit: 20, investigationMedicineType: investigationMedicineType[0] }}
                                url={API_URL.common.queryAllDiseaseList}
                                config={{ id: 'diseaseId', name: 'diseaseName', show: 'disease' }}
                                onChange={option => this.handleChange(option, 'disease')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="疾病分类" {...commonLayout}>
                            { diseaseClassName}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目领域" {...commonLayout}>
                            { investigationAreaName }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="受试者类型" {...commonLayout}>
                            {
                                getFieldDecorator('testeeTypeId', {
                                    rules: [{ required: true, message: '请选择受试者类型' }],
                                    getValueFromEvent: value => this.handleChange(value, 'testeeTypeId')
                                })(
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                        disabled={isBoundBlind}
                                    >
                                        {testeeTypeOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="业务线" {...commonLayout}>
                            { lineOfBusinessString }
                        </FormItem>
                    </Col>
                    {
                        showSecondLine &&
                        <Col span={12}>
                            <FormItem label="执行业务线二级分类" {...commonLayout}>
                                { secondLineNames }
                            </FormItem>
                        </Col>
                    }
                    {
                        secondLineNames === '非盲'  &&
                        <Col span={12}>
                            <FormItem label="配套盲态项目" {...commonLayout}>
                                {
                                    getFieldDecorator('blindInvestigationId')(<Input type="hidden" />)
                                }
                                <SearchRetrieve
                                    keyword='keyword'
                                    style={{ width: '100%' }}
                                    placeholder="输入名称检索"
                                    value={blindInvestigationName}
                                    params={{ limit: 20, queryBlindType: 'BLIND' }}
                                    url={API_URL.investigation.queryInvListByParams}
                                    config={{ id: 'investigationId', name: 'investigationName' }}
                                    onChange={option => this.handleChange(option, 'blindInvestigation')}
                                />
                            </FormItem>
                        </Col>
                    }
                    {
                        isClinicalPro &&
                        <Col span={12}>
                            <FormItem label="项目性质" {...commonLayout}>
                                { invNature }
                            </FormItem>
                        </Col>
                    }
                    <Col span={12}>
                        <FormItem label="项目分类" {...commonLayout}>
                            { investigationTypeName }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="合同签署方" {...commonLayout}>
                            {
                                getFieldDecorator('contractSignCompanyId',
                                    { rules: [{ required: true, message: '请选择合同签署方' }] }
                                )(<Input type="hidden" />)
                            }
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                disabled={isBoundBlind}
                                value={contractSignCompanyName}
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={option => this.handleChange(option, 'contractSignCompany')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="申办方" {...commonLayout}>
                            {
                                getFieldDecorator('investigationSponsorId',
                                    { rules: [{ required: true, message: '请选择申办方' }] }
                                )(<Input type="hidden" />)
                            }
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                disabled={isBoundBlind}
                                value={investigationSponsorName}
                                params={{ limit: 20, natureName: '申办方' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={option => this.handleChange(option, 'sponsor')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="CRO" {...commonLayout}>
                            {
                                getFieldDecorator('croId')(<Input type="hidden" />)
                            }
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                disabled={isBoundBlind}
                                value={croName}
                                params={{ limit: 20, natureName: 'CRO' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={option => this.handleChange(option, 'cro')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石计划负责中心数量' {...commonLayout}>
                            {
                                getFieldDecorator('siteAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        {
                            secondLineNames === '非盲' ?
                            <FormItem label='津石计划知情数量' {...commonLayout}>
                            {
                                getFieldDecorator('informedAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入" />
                                )
                            }
                            </FormItem>
                            :<FormItem label='津石计划知情数量' {...commonLayout}>
                                {informedAmount}
                            </FormItem>
                        }
                        
                    </Col>
                    <Col span={12}>
                        {
                            secondLineNames === '非盲' ? 
                            <FormItem label='津石计划筛选数量' {...commonLayout}>
                                {
                                    getFieldDecorator('filterAmount')(
                                        <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入" />
                                    )
                                }
                            </FormItem>
                            :
                            <FormItem label='津石计划筛选数量' {...commonLayout}>
                                {filterAmount}
                            </FormItem>
                        }
                       
                    </Col>
                    <Col span={12}>
                        {
                            secondLineNames === '非盲' ?
                            <FormItem label='津石计划随机(入组)数量' {...commonLayout}>
                            {
                                getFieldDecorator('randomAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入" />
                                )
                            }
                            </FormItem>
                            :
                            <FormItem label='津石计划随机(入组)数量' {...commonLayout}>
                               {randomAmount}
                            </FormItem>
                        }
                        
                    </Col>
                    <Col span={12}>
                        <FormItem label='合同计划中心数量' {...commonLayout}>
                            {
                                getFieldDecorator('contractSitePlanAmount', {
                                    rules: [
                                        { required: false, message: '请输入合同计划中心数量' },
                                    ],
                                })(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入合同计划中心数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='合同计划随机(入组)数量' {...commonLayout}>
                            {
                                getFieldDecorator('contractRandomPlanAmount', {
                                    rules: [
                                        { required: false, message: '请输入合同计划随机(入组)数量' },
                                    ],
                                })(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入合同计划随机(入组)数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    {/* {showSiteStartTime &&
                        <Col span={12}>
                            <FormItem label='津石第一家研究中心启动计划开始时间' {...commonLayout}>
                                {
                                    getFieldDecorator('firstSiteStartTime', {
                                        rules: [
                                            { required: showSiteStartTime, message: '请选择津石第一家研究中心启动计划开始时间' },
                                        ],
                                    })(
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            format={dateFormat}
                                            placeholder="请选择"
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    } */}
                    {/* {showSiteStartTime &&
                        <Col span={12}>
                            <FormItem label='津石100%中心启动计划开始时间' {...commonLayout}>
                                {
                                    getFieldDecorator('oneHundredPercentSiteStartTime', {
                                        rules: [
                                            { required: showSiteStartTime, message: '请选择津石100%中心启动计划开始时间' },
                                        ],
                                    })(
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            format={dateFormat}
                                            placeholder="请选择"
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    } */}
                    {/* {showGroupStartTime &&
                        <Col span={12}>
                        <FormItem label='津石首例受试者随机（入组）计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('firstPatientGroupStartTime', {
                                    rules: [
                                        { required: showGroupStartTime, message: '请选择津石首例受试者随机（入组）计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>
                    } */}
                    {/* {showGroupStartTime &&
                        <Col span={12}>
                        <FormItem label='津石100%受试者随机（入组）计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('oneHundredPercentGroupStartTime', {
                                    rules: [
                                        { required: showGroupStartTime, message: '请选择津石100%受试者随机（入组）计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>} */}
                </Row>
                <div>2.项目负责人</div>
                <Row>
                    <Col span={24}>
                        <FormItem label="项目经理" {...maxLayout}>
                            {
                                getFieldDecorator('pm', {
                                    initialValue: []
                                })(
                                    <AddProjectRole role="pm" data={pm} visible={visible} onChange={value => this.saveProjectRole('pm', value)} />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="项目管理员" {...maxLayout}>
                            {
                                getFieldDecorator('pa', {
                                    initialValue: []
                                })(
                                    <AddProjectRole role="pa" data={pa} visible={visible} onChange={value => this.saveProjectRole('pa', value)} />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="BD" {...maxLayout}>
                            {
                                getFieldDecorator('bd', {
                                    rules: [{ required: true, message: '请选择BD' }],
                                    initialValue: []
                                })(
                                    <AddProjectRole role="bd" data={bd} visible={visible} onChange={value => this.saveProjectRole('bd', value)} />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="CSA" {...maxLayout}>
                            {
                                getFieldDecorator('csa', {
                                    rules: [{ required: false, message: '请选择BD' }],
                                    initialValue: []
                                })(
                                    <AddProjectRole role="csa" data={csa} visible={visible} onChange={value => this.saveProjectRole('csa', value)} />
                                )
                            }
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }
}

const mapPropsToFields = (props) => {
    const { record, shouldMap } = props;
    if (!shouldMap) {
        return {};
    }
    const {
        diseaseId, diseaseName, diseaseClassName, investigationAreaId, investigationAreaName,
        investigationMedicineType, secondResearchProductType, investigationByStageRemark, investigationByStageId, testeeTypeId,
        lineOfBusinessString, lineOfBusiness, investigationTypeName, secondLineIds, secondLineNames,
        typeId, sponsorId, sponsorName, isClinicalProject, customerProjectCode, createUserId,
        createUserName, createUserEmployeeCode, contractSignCompanyId, contractSignCompanyName
    } = record;
    const fields = {
        isClinicalProject: { value: isClinicalProject },
        investigationCode: { value: customerProjectCode },
        diseaseId: { value: diseaseId },
        diseaseName: { value: diseaseName },
        diseaseClassName: { value: diseaseClassName },
        investigationAreaId: { value: investigationAreaId },
        investigationAreaName: { value: investigationAreaName },
        // Cascader 要求 value 为数组(与 init() 的转换规则一致)，映射成 record 原始字符串会
        // 在字典加载等 setState 触发重映射后覆盖表单值，交互时报
        // "Cannot assign to read only property '0' of string 'T'"
        investigationMedicineType: {
            value: investigationMedicineType
                ? (secondResearchProductType ? [investigationMedicineType, secondResearchProductType] : [investigationMedicineType])
                : [],
        },
        investigationByStageRemark: { value: investigationByStageRemark },
        investigationByStageId: { value: investigationByStageId ? investigationByStageId.split(',') : [] },
        testeeTypeId: { value: testeeTypeId },
        investigationSponsorId: { value: sponsorId },
        investigationSponsorName: { value: sponsorName },
        contractSignCompanyId: { value: contractSignCompanyId },
        contractSignCompanyName: { value: contractSignCompanyName },
        // createUserId=0（如CRM生成的申请单指定人员未配置）或用户已不存在时，后端 createUserName 为 null，
        // 不能映射成假行（会显示 null[null] 且长度为1导致必填校验误通过），映射为空数组强制用户重新选择 BD
        bd: { value: createUserId && createUserName ? [{ value: createUserId, text: `${createUserName}[${createUserEmployeeCode}]` }] : [] }
    };
    // 业务线、项目分类等字段由 autoEvaluation 在疾病/分期数据加载后异步计算写入表单；
    // record 里没有值时不能映射成 undefined——首开弹窗时字典接口的 setState 会反复触发本函数，
    // 把已算出的值重置掉，导致项目简称第一次打开为空、第二次打开才显示
    [
        ['lineOfBusinessString', lineOfBusinessString],
        ['lineOfBusiness', lineOfBusiness],
        ['investigationTypeName', investigationTypeName],
        ['typeId', typeId],
        ['secondLineIds', secondLineIds],
        ['secondLineNames', secondLineNames],
    ].forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            fields[key] = { value };
        }
    });
    return fields;
};

const WrappedCreateForm = Form.create({ mapPropsToFields })(CreateForm);

class CreateProject extends Component {
    state = {
        visible: false,
        loading: false,
        areaList: [],
        typeList: [],
        levelList: [],
        stageList: [],
        testeeTypeList: [],
        treatmentMethodList: [],
        administrationModeList: [],
        record: {},
        type: 'create',
        returnReason: null,
    }

    shouldMap = true;

    dictLoaded = false
    dictPendingCount = 0

    // 字典与项目数据无关，首开一次；任一请求失败则完成数不满足，重开弹窗自动重试
    loadDictData = () => {
        this.dictPendingCount = 3;
        this.loadTypeConfigureList();
        this.queryByParams(
            // { key: 'Treatment_Method', name: 'treatmentMethodList' },
            { key: 'Administration_Mode', name: 'administrationModeList'},
        );
        this.queryTumorTreatMethodList();
    }

    dictLoadedOne = () => {
        this.dictPendingCount -= 1;
        if (this.dictPendingCount <= 0) {
            this.dictLoaded = true;
        }
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ ...res });
            this.dictLoadedOne();
        });
    }

    handleTextAreaChange = value => {
        this.setState({ returnReason: value})
    }

    queryTumorTreatMethodList = () => {
        dictCache.getDict('TUMOR_TREAT_METHOD', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryTumorTreatMethodList,
                data: { limit: 9999 },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ treatmentMethodList: res.datas });
            this.dictLoadedOne();
        });
    }

    queryByParams = (...rest) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const params = {};
                res.typeConfigureList.forEach(i => {
                    const { name } = rest.find(r => r.key === i.typeName) || {};
                    if (name) {
                        if (!params[name]) {
                            params[name] = [];
                        }
                        params[name].push(i);
                    }
                });
                this.setState(params);
                this.dictLoadedOne();
            }
        };
        $.sendRequest(options);
    }

    show = (record, type) => {
        this.shouldMap = true;
        if (!this.dictLoaded) {
            this.loadDictData();
        }
        this.setState({
            type,
            visible: true,
            record: {...record},
        });
    }

    hide = () => {
        const { type } = this.state;
        type !== 'return' && this.formRef.resetFields();
        this.setState({ visible: false, returnReason: null });
    }

    // 提交表单
    handleSubmit = () => {
        const { type, returnReason, loading, record } = this.state;
        const { jdeApplyId, createUserId } = record;
        if( type == 'create' ){
            this.formRef.validateFieldsAndScroll((errors, values) => {
                if (errors) {
                    return;
                }
                // if (loading) {
                //     return;
                // }
                if (!values.customerCompanySpecialName) {
                    message.warning('合同签署方尚未维护客户简称，请联系后台管理员');
                    return;
                }
    
                const { pm, pa, bd, csa, ...params } = values;
                const {
                    customerCompanySpecialName, diseaseName, investigationCode, investigationByStageId,
                    lineOfBusinessString, secondLineNames, stageIds, suspendTime, terminationTime, isClinicalProject, investigationMedicineType = [],
                    firstSiteStartTime, oneHundredPercentSiteStartTime, 
                    firstPatientGroupStartTime, oneHundredPercentGroupStartTime,
                } = params;
                const obj = { idx: 0 };
                getRole(pm, 'PM', params, obj);
                getRole(pa, 'PA', params, obj);
                getRole(bd, 'BD', params, obj);
                getRole(csa, 'CSA', params, obj);
    
                if (suspendTime) {
                    params.suspendTime = suspendTime.format(dateFormat);
                }
                if (terminationTime) {
                    params.terminationTime = terminationTime.format(dateFormat);
                }
                
                params.stageIds = (stageIds || []).join(',');
                params.investigationByStageId = (investigationByStageId || []).join(',');
                params.investigationName = `${customerCompanySpecialName}-${diseaseName}-${investigationCode}（${lineOfBusinessString}${ isClinicalProject == 1 && `-${SecondLineSimple[secondLineNames] || secondLineNames}`}）`;
                params.investigationMedicineType = investigationMedicineType[0];
                params.secondResearchProductType = investigationMedicineType[1];
                params.firstSiteStartTime = firstSiteStartTime ? firstSiteStartTime.format(dateFormat) : undefined;
                params.oneHundredPercentSiteStartTime = oneHundredPercentSiteStartTime ?oneHundredPercentSiteStartTime.format(dateFormat) : undefined;
                params.firstPatientGroupStartTime = firstPatientGroupStartTime ? firstPatientGroupStartTime.format(dateFormat) : undefined;
                params.oneHundredPercentGroupStartTime = oneHundredPercentGroupStartTime ? oneHundredPercentGroupStartTime.format(dateFormat) : undefined;
                this.shouldMap = false;
                this.setState({ loading: true });
                const options = {
                    method: 'POST',
                    url: API_URL.investigation.investigationOptimize,
                    data: {
                        ...params,
                        jdeApplyId,
                        enterpriseId: 1,
                        bdUserId: createUserId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success('新建成功');
                        this.hide();
                        this.setState({ loading: false }, () => {
                            this.props.loadData();
                        });
                    },
                    errorResult: () => {
                        this.shouldMap = false;
                        this.setState({ loading: false });
                    },
                };
                $.sendRequest(options);
            });
        } else if( type == 'return' ){
            if( !returnReason) {
                message.error('请输入打回原因！')
                return
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.contract.ctaBackJdeApply,
                data: {
                    comments: returnReason,
                    jdeApplyId,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success('打回成功！');
                    this.hide();
                    this.setState({ loading: false }, () => {
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.shouldMap = false;
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        }
    }

    render() {
        const { businessList } = this.props;
        const {
            loading, visible, type, record, areaList, typeList, levelList, stageList,
            testeeTypeList, treatmentMethodList, administrationModeList, returnReason = null
        } = this.state;
        const settings = {
            visible,
            areaList,
            typeList,
            levelList,
            stageList,
            testeeTypeList,
            treatmentMethodList,
            administrationModeList,
            businessList,
        };
        return (
            <Modal
                title={type == 'create' ? '创建项目' : '打回'}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal form-item-padding"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
                maskClosable={false}
                width="1250px"
            >
                <h4 className="project-title">JDE建号申请</h4>
                <div className="project-border">
                    <ApplyJdeCodeInfo data={record} visible={visible} {...settings} />
                </div>
                    <h4 className="project-title">{type == 'return' && <span style={{ color: "red" }}>*</span>}{ type == 'create' ? '创建项目' : '打回原因'} </h4>
                    {
                        type == 'create' ?
                        <div className="project-border">
                                <WrappedCreateForm ref={el => this.formRef = el} record={record} shouldMap={this.shouldMap} {...settings} />
                        </div>:
                        <div className="project-border" style={{ border: 0, borderTop: '1px solid #ccc'}}>
                            <TextArea value={returnReason} onChange={ e => this.handleTextAreaChange(e.target.value)} placeholder="请输入打创建项目原因" autosize={{ minRows: 4, maxRows: 5 }} />
                        </div>
                    }
            </Modal>
        );
    }
}

export default CreateProject;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/CreateProject.js